import { MatchEventType } from 'shared/types/match-event';

/**
 * Единственное место, где решается «кто из игроков события забил».
 *
 * У «паса и гола» игроков двое, и порядок в `players` — `[пасующий, забивающий]`
 * (см. контракт в `shared/types/match-event.ts`). До IMGM-1455 оверлей начислял гол
 * нулевому игроку, то есть автору паса: на табло голеадором показывался ассистент.
 * У остальных событий игрок один, и он же автор.
 */
const ASSIST_FIRST_EVENT_TYPES: MatchEventType[] = ['PASS_AND_GOAL'];

/** Индекс автора гола в `event.players`. */
export function getScorerIndex(type: MatchEventType): number {
  return ASSIST_FIRST_EVENT_TYPES.includes(type) ? 1 : 0;
}

/** Индекс ассистента в `event.players` или `undefined`, если у события его нет. */
export function getAssistantIndex(type: MatchEventType): number | undefined {
  return ASSIST_FIRST_EVENT_TYPES.includes(type) ? 0 : undefined;
}
